export default __webpack_public_path__ + "static/media/TDSA_Pyramid_EN.79191ac3.png";